import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

import { Professional, Provider } from '../../../models';
import { StringUtils } from '../../../shared/utils/utils';
import { selectProvidersSelectedBenefit } from '../../../state/providers/providers.selectors';
import { ConfigService } from '../../../services/config.service';

@Component({
  selector: 'provider-details-view',
  templateUrl: './provider-details-view.component.html',
  styleUrl: './provider-details-view.component.scss',
})
export class ProviderDetailsViewComponent {
  @Input() provider!: Provider;
  @Input() province!: string;

  private subscription = new Subscription();
  resolvedSelectedBenefit!: string;
  dateFormat: string = 'MMMM d, y';

  constructor(
    private store: Store,
    private router: Router,
    private configService: ConfigService
  ) {
    this.dateFormat = this.configService.getDateFormat();
  }

  ngOnInit(): void {
    const benefitSub = this.store
      .select(selectProvidersSelectedBenefit)
      .subscribe((benefit) => {
        this.resolvedSelectedBenefit = benefit;
      });
    this.subscription.add(benefitSub);
  }

  generateLinkHtml(url: string, text: string): string {
    return `
      <a href="${url}" target="_blank" rel="noopener" class="document-link-container">
        <img src="assets/images/link-icon.svg" alt="Link Icon" class="document-link-icon" />
        <span>${text}</span>
      </a>
    `;
  }

  getDocumentHtml(document: any): string {
    let content = document?.content || document?.title || '';

    if (document?.content && document?.content.startsWith('http')) {
      return this.generateLinkHtml(document.content, content);
    }
    if (document?.url) {
      return this.generateLinkHtml(document.url, content);
    }
    return content;
  }

  navigateToDisciplinesPage(provider: Provider) {
    if (!provider) return;

    this.router.navigate(['/disciplines'], {
      state: {
        searchData: {
          isSearchByStateParams: true,
          provider,
        },
      },
      queryParams: {
        ben: this.resolvedSelectedBenefit,
        prov: this.province,
        n: provider.name,
      },
    });
  }

  getAddress(provider: Provider) {
    if (!provider) return null;
    const { address, address1, address2, address3, address4 } = provider;
    if (address) return address;

    const combinedAddress = [address1, address2, address3, address4]
      .filter((part) => !!part)
      .join(' ');

    return combinedAddress.length > 0 ? combinedAddress : null;
  }

  get concernTypes(): string {
    const concernTypes = this.provider?.events
      ?.filter((e) => e?.documents?.length > 0)
      ?.map((e) => e?.type)
      ?.filter((type) => !!type);

    return concernTypes?.length ? concernTypes.join(', ') : 'Concerns';
  }

  navigateToProfessionalPage(professional: Professional) {
    if (!professional) return;
    const queryParams = {
      ben: this.resolvedSelectedBenefit,
      prov: this.province,
      n: professional.name,
      id: professional.id,
    };

    this.router.navigate(['/professionals'], {
      queryParams,
    });
  }

  formatUrl(url: string): string {
    return StringUtils.formatUrl(url);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
